
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.MissedTimeWindow = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'MissedTimeWindowEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'timeWindowToleranceContainer'
            }
          }
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet fields
    const timeWindowTolerance = new Monet.UI.Fields.Render({
      name: 'timeWindowTolerance',
      label: 'event.MissedTimeWindow.timeWindowTolerance',
      defaultValue: '0',
      mandatory: false,
      type: 'INTEGER',
    }).render();

    Greenmile.Checks.EventCheck.MissedTimeWindow.fields = { timeWindowTolerance };

    //Append fields to DOM  
    const timeWindowToleranceContainer = document.querySelector('#MissedTimeWindowEvent #timeWindowToleranceContainer');
    timeWindowToleranceContainer.appendChild(timeWindowTolerance.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.MissedTimeWindow.renderFields();
    const fields = Greenmile.Checks.EventCheck.MissedTimeWindow.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.timeWindowTolerance.setValue(jsonParam.timeWindowTolerance);
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.MissedTimeWindow.fields;
    return JSON.stringify({
      timeWindowTolerance: fields.timeWindowTolerance.getValue().toString()
    });
  }

};